import React from 'react';
import { useTranslation } from '@pascal/pascal-core';
import { TKeys } from '../../../../enums';

const RoundStepInfo = ({ roundId, step }) => {
  const t = useTranslation();

  return (
    <>
      <div className='mob-game-big-cards'>
        <div className='mob-game-big-cards-ins'>
          <div className='mob-game-round-id'>
            <div className='mob-game-round-id-inside'>
              <p className='ext-ins-text-id'>{t(TKeys.resultId)}:</p>
              <p className='ext-ins-text-number'>{roundId}</p>
            </div>
          </div>
        </div>
      </div>

      <div className='mob-game-bet-end'>
        <div className='mob-game-bet-end-ins'>
          <p className='mob-game-bet-end-text'>{step}</p>
        </div>
      </div>
    </>
  );
};

export default RoundStepInfo;
